'use strict';

/* global jQuery yith yithStripePayments */

// these constants will be wrapped inside webpack closure, to prevent collisions
const $ = jQuery,
	$document = $( document ),
	$body = $( 'body' ),
	block = ( $el ) => {
		if ( 'undefined' === typeof $.fn.block ) {
			return false;
		}

		try {
			$el.block( {
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6,
				},
			} );

			return $el;
		} catch ( e ) {
			return false;
		}
	},
	unblock = ( $el ) => {
		if ( 'undefined' === typeof $.fn.unblock ) {
			return false;
		}

		try {
			$el.unblock();
		} catch ( e ) {
			return false;
		}
	},
	confirm = ( title, message, args ) => {
		return new Promise( ( resolve, reject ) => {
			// if can't display modal, accept by default
			if ( 'undefined' === typeof yith?.ui?.confirm ) {
				reject( new Error( 'Missing yith.ui utilities' ) );
			}

			let options = {
				title: title || labels.generic_confirm_title,
				message: message || labels.generic_confirm_message,
				...args,
			};

			options.onConfirm = () => resolve( true );
			options.onCancel = reject;

			yith.ui.confirm( options );
		} );
	},
	{
		ajax_url: ajaxUrl,
		labels,
		nonces,
	} = typeof yithStripePayments !== 'undefined' ? yithStripePayments : {};

export {
	$,
	$document,
	$body,
	block,
	unblock,
	confirm,
	ajaxUrl,
	labels,
	nonces,
};
